module.exports = __webpack_public_path__ + "img/Liberia.5e28af09.png";